import angular from 'angular';
import uiRouter from 'angular-ui-router';
import procedureComponent from './procedure.component';
import procedureListComponent from './procedure-list.component';
import procedureDetailComponent from './procedure-detail.component';
import procedureService from './procedure.service';

let procedureModule = angular.module('procedure', [
  uiRouter
])

.service('Procedure', procedureService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/procedure');

  $stateProvider
    .state('procedure', {
      component: 'procedure'
    })
    .state('procedure.list', {
      url: '/procedure',
      component: 'procedureList'
    })
    .state('procedure.create', {
      url: '/procedure/new',
      component: 'procedureDetail',
      params: {
      	id: ""
      }
    })
    .state('procedure.show', {
      url: '/procedure/:id',
      component: 'procedureDetail',
      params: {
        id: ""
      }
    });
})

.component('procedure', procedureComponent)
.component('procedureList', procedureListComponent)
.component('procedureDetail', procedureDetailComponent)

.name;

export default procedureModule;



// WEBPACK FOOTER //
// ./client/app/components/procedure/procedure.js